import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendCustomFormat, BackendMutationCreateCustomFormatArgs } from 'src/types/backend';

import { FRAGMENT_CUSTOM_FORMAT } from './schema';

const MUTATION = gql`
  mutation CreateCustomFormat(
    $brandVoiceId: ID!
    $name: String!
    $instructions: String!
    $defaultForGenerationTools: [GenerationToolEnum!]
  ) {
    createCustomFormat(
      brandVoiceId: $brandVoiceId
      name: $name
      instructions: $instructions
      defaultForGenerationTools: $defaultForGenerationTools
    ) {
      ...CustomFormat
    }
  }
  ${FRAGMENT_CUSTOM_FORMAT}
`;

type Variables = BackendMutationCreateCustomFormatArgs;
type Result = BackendCustomFormat;

export const createCustomFormat = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
